<template>
  <html>
    <body class="ovrflow desk_bckgnd_img_login">
      <Header></Header>
      <!-- <b-container class="bv-example-row login_cont_height container_height mob_col_padding">
        <b-row class="justify-content-md-center dev_lr_margin row_height"> -->
      <!-- <b-col lg="5" class="mob_col_padding dev_position"> -->
      <!-- <b-col class="col-sm-8 col-md-6 col-lg-5 mob_col_padding dev_position"> -->
      <!-- <b-col class="xs_col col-sm-8 col-md-6 col-lg-4 mob_col_padding dev_position"> -->
      <div class="college_main_div">
         <b-container class="bv-example-row login_cont_height mob_col_padding">    
            <b-row align-h="center" class="dev_lr_margin row_height">    
            <b-col class="xs_col col-sm-7 col-md-7 col-lg-5 mob_col_padding dev_position">
              <b-container class="mob-display brand--logo">
                <b-row>
                  <b-col cols="2" class="text-center">
                    <div class="bck-btn">
                      <b-button type="Back" variant="outline-light" v-on:click="backAction">
                        <img src="images/back_blue.png" />
                      </b-button>
                    </div>
                  </b-col>
                  <b-col class="mob-display" cols="8" v-if="store.isLogoAvailable">
                    <div class="text-center">
                      <img :src="store.groupDetail.cssp" alt class="img-responsive-class" />
                    </div>
                  </b-col>
                  <b-col class="mob-display" cols="8" v-if="!store.isLogoAvailable">
                    <div class="text-center">
                      <p class="init-header-title">{{ store.groupDetail.gnm }}</p>
                    </div>
                  </b-col>
                </b-row>
              </b-container>
              <!-- <b-container class="app contentdiv"> -->
              <b-container class="contentdiv">
                <b-row>
                  <b-col>
                    <p class="title_text forgotpw_mar_top">FORGOT PASSWORD</p>
                  </b-col>
                </b-row>
                <div class="main_form">
                  <b-container>
                    <div>
                      <input
                        class="inputstyle"
                        id="input-1"
                        placeholder="Email Address"
                        type="email"
                        v-model="form.eml"
                        autocomplete="off"
                        required
                      />
                    </div>
                    <div class="setpassword__controls">
                      <b-button v-if="showContinueButton" type="login" variant v-on:click="onSubmit">{{ this.continue }}</b-button>
                      <b-button class="desk_display" type="Back" variant="" v-on:click="backAction">
                        {{ this.back }}
                      </b-button>
                      <b-button v-if="showHomeButton" type="home" variant v-on:click="goHome">{{ this.goLogin }}</b-button>
                      <br />
                      <br />
                      <label v-if="errorStatus" class="setpassword_errorMessageLabel" id="errorLabel">{{ errorMessage }}</label>
                      <label v-if="successStatus" class="forgetpassword_successMessage" id="successLabel">{{ successMessage }}</label>
                    </div>
                  </b-container>
                </div>
              </b-container>
            </b-col>
          </b-row>
        </b-container>
      </div>
      <Footer></Footer>
    </body>
  </html>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Header from "@/components/header";
import Footer from "@/components/footer";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      form: {
        eml: "",
      },
      store: store,
      errorStatus: false,
      errorMessage: "",
      successStatus: false,
      successMessage: "",
      showHomeButton: false,
      showContinueButton: true,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      var header = {};
    //     headers: [
    //       {
    //         key: "Content-Type",
    //         value: "application/json",
    //         type: "text",
    //       },
    //     ],
    //   };
    
      if (this.form.eml.length > 0) {
        if (!this.reg.test(this.form.eml)) {
          this.errorStatus = true;
          this.errorMessage = "Email-ID is not valid";
        } else {
          if (navigator.onLine) {
            apiCall
              .apiServiceCall("Post", "", "/user/forgetpassword", this.form, header)
              .then(response => {
                if (response.data.status == 1) {
                  this.errorStatus = false;
                  this.successStatus = true;
                  this.successMessage = response.data.message;
                  // change the color of the input field on error condition
                  var successDiv = document.querySelector(".inputstyle");
                  successDiv.style.borderBottom = "1px solid #ffffff";
                  this.showHomeButton = true;
                  this.showContinueButton = false;
                } else {
                  this.showContinueButton = true;
                  this.showHomeButton = false;
                  this.errorStatus = true;
                  this.errorMessage = response.data.message;
                }
              })
              .catch(error => {
                if (error.response.status == 500) {
                  this.errorStatus = true;
                  this.errorMessage = this.serverProblem;
                } else if (error.response.status == 401) {
                  setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                } else if (error.response.status == 504) {
                  this.signout();
                } else {
                  this.errorStatus = true;
                  this.errorMessage = error.response.data.message;
                }
              });
          } else {
            this.errorStatus = true;
            this.errorMessage = this.checkInternetConnection;
          }
        }
      } else {
        this.errorStatus = true;
        this.errorMessage = "Email-ID cannot be empty";
      }
    },
    backAction() {
      this.$router.push({ path: "/login" });
    },
    goHome() {
      this.$router.push({ path: "/login" });
    },
    hideAndShowPassword() {
      if (document.getElementById("input-1").type === "password") {
        this.hidePasswordSrc = this.showPasswordSrc;
        document.getElementById("input-1").type = "text";
      } else {
        this.hidePasswordSrc = "images/hide password_active.png";
        document.getElementById("input-1").type = "password";
      }
    },
    hideAndShowConfirmPassword() {
      if (document.getElementById("input-2").type === "password") {
        this.hideConfirmPasswordSrc = this.showConfirmPasswordSrc;
        document.getElementById("input-2").type = "text";
      } else {
        this.hideConfirmPasswordSrc = "images/hide password_active.png";
        document.getElementById("input-2").type = "password";
      }
    },
  },
};
</script>
